import type { PageConfigsMap, MasterPageConfigsMap, PageServicesConfigsMap } from '@wix/thunderbolt-vsm-api-types'
import { pageConfig as canvasPageConfig } from 'feature-canvas/configs'
import { pageConfig as landingPagePageConfig } from 'feature-landing-page/configs'
import { masterPageConfig as mpaNavigationMasterPageConfig } from 'feature-mpa-navigation/configs'
import { pageConfig as pageTransitionsPageConfig } from 'feature-page-transitions/configs'
import { pageConfig as scrollRestorationPageConfig } from 'feature-scroll-restoration/configs'
import { pageConfig as accessibilityBrowserZoomPageConfig } from 'feature-accessibility-browser-zoom/configs'
import { pageConfig as lightboxServicePageConfig } from 'feature-lightbox-service/configs'
import { pageConfig as anchorsServicePageConfig } from 'feature-anchors-service/configs'
import { pageConfig as sdkStateServicePageConfig } from 'feature-sdk-state-service/configs'
import { pageConfig as wixEmbedsApiPageConfig } from 'feature-wix-embeds-api/configs'
import { masterPageConfig as pagesMasterPageConfig } from 'feature-pages/configs'
import { masterPageConfig as reporterMasterPageConfig } from 'feature-reporter/configs'
import { masterPageConfig as passwordProtectedPageMasterPageConfig } from 'feature-password-protected-page/configs'
import { masterPageConfig as environmentServiceMasterPageConfig } from 'feature-environment-service/configs'
import { masterPageConfig as translationsMasterPageConfig } from 'feature-translations/configs'
import { pageConfig as sliderGalleryPageConfig } from 'feature-slider-gallery/configs'
import { pageConfig as animationsPageConfig } from 'feature-animations/configs'
import { pageConfig as pageAnchorsPageConfig, masterPageConfig as pageAnchorsMasterPageConfig } from 'feature-page-anchors/configs'
import { pageConfig as lightboxPageConfig, masterPageConfig as lightboxMasterPageConfig } from 'feature-lightbox/configs'
import { pageConfig as hoverBoxPageConfig } from 'feature-hover-box/configs'
import { pageConfig as menuContainerPageConfig } from 'feature-menu-container/configs'
import { pageConfig as searchBoxPageConfig } from 'feature-search-box/configs'
import { pageConfig as repeatersPageConfig } from 'feature-repeaters/configs'
import { pageConfig as onloadCompsBehaviorsPageConfig } from 'feature-onload-comps-behaviors/configs'
import { pageConfig as customCssPageConfig } from 'feature-custom-css/configs'
import {
	pageConfig as stickyToComponentPageConfig,
	masterPageConfig as stickyToComponentMasterPageConfig,
} from 'feature-sticky-to-component/configs'
import { pageConfig as imagePlaceholderPageConfig } from 'feature-image-placeholder/configs'
import { masterPageConfig as componentsLoaderMasterPageConfig } from '@wix/thunderbolt-components-loader/configs'
import { masterPageConfig as ooiMasterPageConfig } from 'feature-ooi/configs'

export const serviceNameToDefinitionMap = {
	[sdkStateServicePageConfig.name]: '@wix/viewer-service-sdk-state',
	[lightboxServicePageConfig.name]: '@wix/viewer-service-lightbox',
	[anchorsServicePageConfig.name]: '@wix/viewer-service-anchors',
}

export const pageServicesConfigsFactories: PageServicesConfigsMap = {
	[sdkStateServicePageConfig.name]: sdkStateServicePageConfig,
	[lightboxServicePageConfig.name]: lightboxServicePageConfig,
	[anchorsServicePageConfig.name]: anchorsServicePageConfig,
}

export const pageConfigsFactories: PageConfigsMap = {
	[landingPagePageConfig.name]: landingPagePageConfig,
	[canvasPageConfig.name]: canvasPageConfig,
	[pageTransitionsPageConfig.name]: pageTransitionsPageConfig,
	[scrollRestorationPageConfig.name]: scrollRestorationPageConfig,
	[accessibilityBrowserZoomPageConfig.name]: accessibilityBrowserZoomPageConfig,
	[wixEmbedsApiPageConfig.name]: wixEmbedsApiPageConfig,
	[sliderGalleryPageConfig.name]: sliderGalleryPageConfig,
	[animationsPageConfig.name]: animationsPageConfig,
	[pageAnchorsPageConfig.name]: pageAnchorsPageConfig,
	[lightboxPageConfig.name]: lightboxPageConfig,
	[hoverBoxPageConfig.name]: hoverBoxPageConfig,
	[menuContainerPageConfig.name]: menuContainerPageConfig,
	[searchBoxPageConfig.name]: searchBoxPageConfig,
	[repeatersPageConfig.name]: repeatersPageConfig,
	[onloadCompsBehaviorsPageConfig.name]: onloadCompsBehaviorsPageConfig,
	[customCssPageConfig.name]: customCssPageConfig,
	[stickyToComponentPageConfig.name]: stickyToComponentPageConfig,
	[imagePlaceholderPageConfig.name]: imagePlaceholderPageConfig,
	...pageServicesConfigsFactories,
}

export const masterPageConfigsFactories: MasterPageConfigsMap = {
	[mpaNavigationMasterPageConfig.name]: mpaNavigationMasterPageConfig,
	[pagesMasterPageConfig.name]: pagesMasterPageConfig,
	[reporterMasterPageConfig.name]: reporterMasterPageConfig,
	[passwordProtectedPageMasterPageConfig.name]: passwordProtectedPageMasterPageConfig,
	[environmentServiceMasterPageConfig.name]: environmentServiceMasterPageConfig,
	[translationsMasterPageConfig.name]: translationsMasterPageConfig,
	[pageAnchorsMasterPageConfig.name]: pageAnchorsMasterPageConfig,
	[lightboxMasterPageConfig.name]: lightboxMasterPageConfig,
	[stickyToComponentMasterPageConfig.name]: stickyToComponentMasterPageConfig,
	[componentsLoaderMasterPageConfig.name]: componentsLoaderMasterPageConfig,
	[ooiMasterPageConfig.name]: ooiMasterPageConfig,
}

export { propsMappersRegistry } from './propsMappers'
